import { addPanelPassthrough } from '../../panels/helpers';
import { Connection } from '../../connections/connection.class';
import { Panel } from '../../panels/panel.class';
import { ReferenceMap } from '../../shared.types';

export type AddIslandPassthroughParams = {
    connection: Connection;
    refMap: ReferenceMap;
};

export const addIslandPassthrough = (params: AddIslandPassthroughParams): number => {
	const { connection, refMap } = params;
	let numAdded = 0;

	numAdded += addPanelPassthrough({ panel: connection.sourcePanel as Panel, refMap });
	numAdded += addPanelPassthrough({ panel: connection.targetPanel as Panel, refMap });

	if (numAdded > 0) {
		console.info('%cPassthroughs were added to the island\'s panels.', 'color:green;font-weight:bold;border:1px solid black;padding:5px;');
	}

	return numAdded;
};
